import { LookupDataType } from "../../models/LookupTable"
import { TableColumn } from "../../models/Table"

export const lookupDisplayNames = {
    rows: "Lookup Table",
}

export const getLookupValidatorModel = (rows: LookupDataType[], columns: TableColumn<LookupDataType>[]) => {
    const requiredColumns = columns
        .filter((col: TableColumn<LookupDataType>) => col.required)
        .map((col: TableColumn<LookupDataType>) => col.id)

    return {
        model: { rows },
        display_names: lookupDisplayNames,
        required_fields: [],
        unique_fields: [],
        custom_validation_fields: [
            {
                name: "rows",
                validation: "required_in_array",
                value: requiredColumns,
                text: `Required fields cannot be empty: ${requiredColumns.join(", ")}`,
            },
        ],
        groups: {},
    }
}
